function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function requestParams(txmsg) {
  if (txmsg !== null && txmsg !== void 0 && txmsg.data && _typeof(txmsg.data) === 'object' && !Array.isArray(txmsg.data)) {
    return txmsg.data;
  }
  return txmsg || {};
}
function success(data) {
  return {
    success: true,
    data: data
  };
}
function failure(error) {
  return {
    success: false,
    error: error
  };
}
module.exports = {
  requestParams: requestParams,
  success: success,
  failure: failure
};